import Api from '@/services/Api';
import PythonApi from '@/services/PythonApi';

export default {
  resetDemo(){
    return PythonApi().post("reset-demo");
  }
};



// WEBPACK FOOTER //
// ./src/services/DemoFarmService.js